import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { ChevronLeft, ChevronRight } from 'lucide-react';

const pages = [
  { path: '/', label: 'Accueil' },
  { path: '/mariage', label: 'Le mariage' },
  { path: '/hebergement', label: 'Hébergement' },
  { path: '/logistique', label: 'Logistique' },
  { path: '/galerie', label: 'Galerie' },
  { path: '/cadeaux', label: 'Cadeaux' },
  { path: '/rsvp', label: 'RSVP' },
];

export const MobileBottomNav = () => {
  const location = useLocation();
  const navigate = useNavigate();
  
  // Find current page index
  const currentIndex = pages.findIndex(page => page.path === location.pathname);
  
  // Don't show on admin page or if page not found
  if (currentIndex === -1 || location.pathname === '/admin') {
    return null;
  }
  
  const hasPrev = currentIndex > 0;
  const hasNext = currentIndex < pages.length - 1;
  
  const goToPrev = () => {
    if (hasPrev) {
      navigate(pages[currentIndex - 1].path);
    }
  };
  
  const goToNext = () => {
    if (hasNext) {
      navigate(pages[currentIndex + 1].path);
    }
  };

  return (
    <nav 
      className="md:hidden"
      style={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        width: '100%',
        zIndex: 9999,
        backgroundColor: '#fcf6f1',
        borderTop: '1px solid #e8ddd4',
        boxShadow: '0 -4px 6px -1px rgba(0, 0, 0, 0.1)'
      }}
      data-testid="mobile-bottom-nav"
    >
      <div className="flex items-center justify-between px-4 py-3">
        {/* Previous Button */}
        <button
          onClick={goToPrev}
          disabled={!hasPrev}
          className={`flex items-center gap-1 px-4 py-2 rounded-full transition-all duration-200 ${
            hasPrev 
              ? 'bg-white border border-[#e8ddd4] text-[#8d5f3f] hover:bg-[#e17c3b]/10 active:scale-95' 
              : 'bg-transparent text-[#8d5f3f]/30 cursor-not-allowed'
          }`}
          data-testid="prev-button"
        >
          <ChevronLeft className="w-4 h-4" />
          <span className="text-sm font-medium">Précédent</span>
        </button>

        {/* Page Indicator */}
        <div className="flex flex-col items-center">
          <span className="text-[#e17c3b] font-display text-lg">
            {currentIndex + 1}/{pages.length}
          </span>
          <span className="text-[#8d5f3f]/60 text-xs">
            {pages[currentIndex].label}
          </span>
        </div>

        {/* Next Button */}
        <button
          onClick={goToNext}
          disabled={!hasNext}
          className={`flex items-center gap-1 px-4 py-2 rounded-full transition-all duration-200 ${
            hasNext 
              ? 'bg-[#e17c3b] text-white hover:bg-[#c96a2f] active:scale-95' 
              : 'bg-transparent text-[#8d5f3f]/30 cursor-not-allowed'
          }`}
          data-testid="next-button"
        >
          <span className="text-sm font-medium">Suivant</span>
          <ChevronRight className="w-4 h-4" />
        </button>
      </div>
    </nav>
  );
};

export default MobileBottomNav;
